export type AttachmentKind = 'archive' | 'document' | 'file' | 'image'

export function formatAttachmentSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB']
  let value = bytes / 1024
  let unit = units[0]
  for (let index = 1; index < units.length && value >= 1024; index += 1) {
    value /= 1024
    unit = units[index]
  }
  const rounded = value >= 10 || Number.isInteger(value) ? Math.round(value) : Math.round(value * 10) / 10
  return `${rounded} ${unit}`
}

export function attachmentKind(contentType: string): AttachmentKind {
  if (contentType.startsWith('image/')) return 'image'
  if (/pdf|text|word|document|sheet|presentation/iu.test(contentType)) return 'document'
  if (/zip|archive|compressed|tar|rar|7z/iu.test(contentType)) return 'archive'
  return 'file'
}
